module.exports = __webpack_public_path__ + "tbanner.png?b97208f407972f95ea70faff49ee725a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tbanner.png
// module id = 267
// module chunks = 0